import moment from 'moment';

export const transformReceivedDeactivationDates = (
  dates,
  startKey = 'fromDate',
  endkey = 'toDate'
) => {
  return dates
    .filter(
      ({ deactivationBooking, isCanceled }) =>
        deactivationBooking && !isCanceled
    )
    .map(({ [startKey]: fromDate, [endkey]: toDate, id }) => ({
      id,
      startDate: moment(fromDate),
      endDate: moment(toDate)
    }));
};
